import { i18n } from '@/locales';
import {
  parsePhoneNumberWithError
} from 'libphonenumber-js';
import store from '@/store';

const isMobileNumber = {
    message: () => i18n.t('The value must be a valid mobile number'),
    validate(telNo) {
        const cleanedTelNo = cleanTelephone(telNo);
        return isValidTelephone(cleanedTelNo) && (cleanedTelNo.substring(0, 2) === '07');
    },
};

const isLandLineNumber = {
    message: () => i18n.t('The value must be a valid land line number'),
    validate(telNo) {
        const cleanedTelNo = cleanTelephone(telNo);
        return isValidTelephone(cleanedTelNo) && !isMobileNumber.validate(cleanedTelNo);
    }
};

const isPhoneNumber = {
    message: () => i18n.t('Please enter a valid phone number'),
    validate(telNo) {
        const cleanedTelNo = cleanTelephone(telNo);
        return isValidTelephone(cleanedTelNo);
    }
};

const isNotPremiumTelephone = {
    message: () => i18n.t('Please enter a valid phone number'),
    validate(telNo) {
        const cleanedTelNo = cleanTelephone(telNo);
        const telBeginning = cleanedTelNo.substr(0, 2);
        return !(telBeginning === '09' || telBeginning === '08');
    }
};

const isValidTelephone = function(telNo) {
    // NOTE expects a pre-cleaned number
    if (!/^\d+$/.test(telNo)) {
        // has non-numeric characters
        return false;
    }
    var valid = true;
    var len = telNo.length;
    var begin = telNo.substr(0, 2);
    var first = telNo.substr(0, 1);
  // eslint-disable-next-line max-len
    var ukPhoneRegex = new RegExp('^(?:(?:\\(?(?:0(?:0|11)\\)?[\\s-]?\\(?|\\+)44\\)?[\\s-]?(?:\\(?0\\)?[\\s-]?)?)|(?:\\(?0))(?:(?:\\d{5}\\)?[\\s-]?\\d{4,5})|(?:\\d{4}\\)?[\\s-]?(?:\\d{5}|\\d{3}[\\s-]?\\d{3}))|(?:\\d{3}\\)?[\\s-]?\\d{3}[\\s-]?\\d{3,4})|(?:\\d{2}\\)?[\\s-]?\\d{4}[\\s-]?\\d{4}))(?:[\\s-]?(?:x|ext\\.?|\\#)\\d{3,4})?$');
    var validPhoneNumber = ukPhoneRegex.test(telNo.replace(/ /g, ''));

    if (telNo === '00000000000') {
        valid = false;
    } else if (validPhoneNumber === false) {
        valid = validPhoneNumber;
    }

    if (first !== '0') {
        valid = false;
    } else {
        if (telNo.substr(0, 2) === '00') {
            // International number
            if (len < 7) {
                // too short to reach another country
                valid = false;
            }
        } else {
            if ((len > 11) || (len < 9)) {
                valid = false;
            } else {
                if ((begin === '07') && (len !== 11)) {
                    valid = false;
                } else if ((begin === '02') && (len !== 11)) {
                    valid = false;
                } else if ((begin === '04') || (begin === '06')) {
                    valid = false;
                } else if ((begin === '01') && (len !== 11)) {
                    valid = isValidShortNumber(telNo);
                }
            }
        }
    }

    if ((len === 11) && valid) {
        if (telNo.substr(0, 10) === '0123456789') {
            valid = false;
        }
    }
    return valid;
}

const isValidShortNumber = function(telNo) {
  // Checks the exceptional numbers (01X, len less than 11)
  // NOTE expects a pre-cleaned number
  let valid = false;
  const len = telNo.length;
  let begin = telNo.substr(0, 7);

  if ((begin === '0169772' || begin === '0169773') && len === 9) {
    valid = true;
  }

  if (len === 11) {
    valid = true;
  } else  if (len === 10) {
    const validAreaCodes = [
      '176888','142087','152768','142089','152760','146067','142088','160674','142085','127663','142083','146064','127624','175022','127661',
      '146068','146078','146054','127629','146053','146061','196333','138640','138475','127625','190529','165967','138478','127626','138648',
      '175062','138641','188434','138647','129828','142081','142084','140444','190067','140445','140443','172668','152461','152432','152769',
      '142023','152437','152439','152435','152433','152466','138476','146065','152765','182768','190528','152762','196334','188432','142086',
      '152764','152766','190527','152464','182766','152462','146140','182760','146052','156268','146075','146062','146072','127666','163534',
      '199561','152460','152465','148871','148052','152469','152468','148872','129827','169552','127633','146074','127636','160677','120874',
      '129721','127662','142080','127620','127631','127621','190065','127665','127634','127628','127622','127664','142082','120872','120461',
      '138470','129734','120875','120464','120463','125453','120877','120462','125457','125455','127637','125456','120879','120873','194663',
      '183782','125452','160648','129874','129826','129822','138477','129884','175021','172674','136382','129877','152434','129825','146063',
      '129732','172663','138479','125454','136384','136383','136472','136473','136385','182758','152463','129824','120876','146030','127635',
      '163542','129720','172677','129724','172671','174425','152436','129870','129883','129722','160646','129873','129885','129872','182761',
      '182762','125459','129723','182755','190524','175032','190521','182767','182764','183754','182756','175052','183753','163532','182757',
      '182753','183755','183752','172665','142022','188438','127638','175082','175023','174421','146055','175042','175020','175076','182769',
      '140447','146066','182751','182754','162957','160649','182759','182750','146073','194668','194666','190523','196331','194662','194921',
      '190520','190085','194667','190066','193583','129733','194981','163539','196323','196332','194661','194664','160679','194665','194920',
      '190063','174424','182752','163546','127627','188435','152763','190062','156269','146077','129879','172667','140442','190522','152761',
      '190061','174422','182765','190525','190526','163530','162955','163544','163533','163543','162956','138649','163531','163548','129878',
      '163537','163535','163536','148873','163549','188433','163541','183783','163540','163538','160647','156266','160675','138645','125451',
      '156260','146057','156686','156267','140441','160640','160644','160676','129735','160643','152767','160642','190068','160645','182763',
      '172676','129823','120878','174429','169553','183789','138474','165974','172661','172673','172666','174420','129871','174423','174426',
      '127623','172669','146076','174428','152467','174427','160641','190064','172675','165966','165958','163547','163545','165950','164761',
      '164724','140446','172670','172672','172664','169554','169551','127632','169550','176888','142087','152768','142089','152760','146067',
      '142088','160674','142085','127663','142083','146064','127624','175022','127661','146068','146078','146054','127629','146053','146061',
      '196333','138640','138475','127625','190529','165967','138478','127626','138648','175062','138641','188434','138647','129828','142081',
      '142084','140444','190067','140445','140443','172668','152461','152432','152769','142023','152437','152439','152435','152433','152466',
      '138476','146065','152765','182768','190528','152762','196334','188432','142086','152764','152766','190527','152464','182766','152462',
      '146140','182760','146052','156268','146075','146062','146072','127666','163534','199561','152460','152465','148871','148052','152469',
      '152468','148872','129827','169552','127633','146074','127636','160677','120874','129721','127662','142080','127620','127631','127621',
      '190065','127665','127634','127628','127622','127664','142082','120872','120461','138470','129734','120875','120464','120463','125453',
      '120877','120462','125457','125455','127637','125456','120879','120873','194663','183782','125452','160648','129874','129826','129822',
      '138477','129884','175021','172674','136382','129877','152434','129825','146063','129732','172663','138479','125454','136384','136383',
      '136472','136473','136385','182758','152463','129824','120876','146030','127635','163542','129720','172677','129724','172671','174425',
      '152436','129870','129883','129722','160646','129873','129885','129872','182761','182762','125459','129723','182755','190524','175032',
      '190521','182767','182764','183754','182756','175052','183753','163532','182757','182753','183755','183752','172665','142022','188438',
      '127638','175082','175023','174421','146055','175042','175020','175076','182769','140447','146066','182751','182754','162957','160649',
      '182759','182750','146073','194668','194666','190523','196331','194662','194921','190520','190085','194667','190066','193583','129733',
      '194981','163539','196323','196332','194661','194664','160679','194665','194920','190063','174424','182752','163546','127627','188435',
      '152763','190062','156269','146077','129879','172667','140442','190522','152761','190061','174422','182765','190525','190526','163530',
      '162955','163544','163533','163543','162956','138649','163531','163548','129878','163537','163535','163536','148873','163549','188433',
      '163541','183783','163540','163538','160647','156266','160675','138645','125451','156260','146057','156686','156267','140441','160640',
      '160644','160676','129735','160643','152767','160642','190068','160645','182763','172676','129823','120878','174429','169553','183789',
      '138474','165974','172661','172673','172666','174420','129871','174423','174426','127623','172669','146076','174428','152467','174427',
      '160641','190064','172675','165966','165958','163547','163545','165950','164761','164724','140446','172670','172672','172664','169554',
      '169551','127632','169550'
    ];
    begin = telNo.substr(1, 6);
    valid = validAreaCodes.includes(begin);
  }
  return valid;
}

const cleanTelephone = function(telNo) {
  // eslint-disable-next-line no-param-reassign
    telNo = telNo.replace(/[ -]/g, '');
  // eslint-disable-next-line no-param-reassign
    telNo = telNo.replace(/o/gi, '0');

  if (telNo.length > 1) {
    if (telNo.substr(0,1) === '+') {
      // eslint-disable-next-line no-param-reassign
      telNo = '00' + telNo.substr(1,telNo.length);
    }
  }

  if (telNo.length > 4) {
    if (telNo.substr(0,4) === '0044') {
      // eslint-disable-next-line no-param-reassign
      telNo = '0' + telNo.substring(4, telNo.length);
    }
  }

  if ((telNo === '00') || (telNo === '0')) {
    // eslint-disable-next-line no-param-reassign
    telNo = '';
  }

  return telNo;
}

const isValidIntlPhoneNumber = {
  message: () => i18n.t('Please enter a valid phone number'),
  validate(telNo, countryCode) {
    try {
      let countryIsoCode = 'GB';

      if (countryCode) {
        countryIsoCode = countryCode[0].toUpperCase();
      } else if (store.state.country) {
        countryIsoCode = store.state.country;
      }

      const phoneNumber = parsePhoneNumberWithError(telNo, countryIsoCode);

      return phoneNumber.isValid();
    } catch (error) {
      return false;
    }
  }
}

export {
  isMobileNumber,
  isLandLineNumber,
  isPhoneNumber,
  isNotPremiumTelephone,
  isValidIntlPhoneNumber,
};
